import { components } from "../../services/api/banking/types";

export const selectorActiveBankingAccount = (
  internalAccount: components["schemas"]["InternalAccount"]
) => internalAccount.type === "Banking" && internalAccount.status === "Active";
